var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.nodes),function(node,n){return _c('span',{key:'word_' + n},[(n % 2)?_c('label-text',{attrs:{"to":node}}):[_c('nl2br',{attrs:{"tag":"span","text":node}})]],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }